import React, { useState, useEffect } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { UI_CONSTANTS } from "../../utils/constants";

function UpdateDish() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
  });
  const [selectedDishCategory, setSelectedDishCategory] = useState(null);

  // Get dish category data from localStorage (set when edit button is clicked)
  useEffect(() => {
    const dishCategoryData = localStorage.getItem(UI_CONSTANTS.LOCAL_STORAGE_KEYS.SELECTED_DISH_CATEGORY);
    if (dishCategoryData) {
      const parsedData = JSON.parse(dishCategoryData);
      setSelectedDishCategory(parsedData);
      setFormData({
        name: parsedData.name || "",
      });
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error("Please enter dish category name");
      return;
    }

    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(formData.name.trim())) {
      toast.error("Dish category name should only contain letters and spaces");
      return;
    }

    setLoading(true);
    try {
      const response = await handleApiCall("patch", `${endpoints.updateDishCategory}/${id}`, {
        name: formData.name,
      });

      if (response?.data?.code === 200) {
        toast.success(response?.data?.message || "Dish category updated successfully!");
        // Clean up localStorage
        localStorage.removeItem(UI_CONSTANTS.LOCAL_STORAGE_KEYS.SELECTED_DISH_CATEGORY);
        // Add a small delay to ensure toast is shown before navigation
        setTimeout(() => {
          navigate("/dish-categories");
        }, 1000);
      }
      // API errors are already handled by handleApiCall
    } catch (error) {
      console.error("Error updating dish category:", error);
      // Network errors are already handled by handleApiCall
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: "",
    });
    // Clean up localStorage
    localStorage.removeItem(UI_CONSTANTS.LOCAL_STORAGE_KEYS.SELECTED_DISH_CATEGORY);
    navigate("/dish-categories");
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Update Dish Category</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <form onSubmit={handleSubmit}>
                <div className="card-heading d-flex align-items-center mb-3 pb-2">
                  <div className="d-flex align-items-center justify-content-start col-md-12 px-0">
                    <Button type="submit" className="rounded-lg" disabled={loading}>
                      {loading ? "Updating..." : "Update"}
                    </Button>
                    <Button type="button" className="rounded-lg ml-4 bg-white" onClick={handleCancel} disabled={loading}>
                      Cancel
                    </Button>
                  </div>
                </div>
                <h5 className="text-white mt-4 mb-3">DISH CATEGORY</h5>
                <div className="row mx-n2">
                  <div className="form-group col-md-4 px-2">
                    <input type="text" className="form-control default" placeholder="Dish Category Name" name="name" value={formData.name} onChange={handleInputChange} required />
                  </div>
                  {/* Commented out other fields as per requirement */}
                  {/* <div className="form-group col-md-8 px-2">
                    <input type="text" className="form-control default" placeholder="Description" />
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <input type="text" className="form-control default" placeholder="Price" />
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <select className="form-control default">
                      <option>Select Size</option>
                    </select>
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <select className="form-control default">
                      <option>Select Size</option>
                    </select>
                  </div> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateDish;
